import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { siteConfig } from '../config/siteConfig';
import { Shield, Mail, MapPin } from 'lucide-react';
import PageHeader from '../components/PageHeader';

const PrivacyStatement: React.FC = () => {
    const { t } = useLanguage();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-maat-stone min-h-screen">
            <PageHeader
                title={t.legal.privacyTitle}
                subtitle={t.legal.privacyVersion}
            />

            {/* Content Section */}
            <section className="py-20 font-sans">
                <div className="container mx-auto px-6">
                    <div className="max-w-4xl mx-auto space-y-12 text-maat-blue/80">

                        <div className="bg-white p-8 md:p-12 rounded-4xl border border-maat-sand shadow-sm space-y-8">
                            <div className="flex items-center space-x-4 mb-4">
                                <div className="p-3 bg-maat-stone rounded-2xl">
                                    <Shield className="text-maat-gold" size={32} />
                                </div>
                                <h2 className="text-3xl font-serif text-maat-blue">{t.legal.privacyTitle}</h2>
                            </div>

                            <p className="text-lg leading-relaxed">{t.legal.privacyGeneral}</p>

                            {t.legal.privacySections.map((section) => (
                                <div key={section.title}>
                                    <h3 className="text-xl font-serif text-maat-blue mb-4 font-bold">{section.title}</h3>
                                    {section.paragraphs && (
                                        <div className="space-y-4">
                                            {section.paragraphs.map((text) => <p key={text}>{text}</p>)}
                                        </div>
                                    )}
                                    {section.items && (
                                        <ul className={`list-disc pl-6 space-y-2${section.paragraphs ? ' mt-4' : ''}`}>
                                            {section.items.map((item) => <li key={item}>{item}</li>)}
                                        </ul>
                                    )}
                                    {section.after && (
                                        <div className="space-y-4 mt-4">
                                            {section.after.map((text) => <p key={text}>{text}</p>)}
                                        </div>
                                    )}
                                </div>
                            ))}

                            <div className="pt-8 border-t border-maat-sand/50">
                                <h3 className="text-xl font-serif text-maat-blue mb-6 font-bold">{t.legal.privacyContact.title}</h3>
                                <p className="mb-6">{t.legal.privacyContact.text}</p>
                                <div className="space-y-4">
                                    <p className="font-bold">{siteConfig.legalName}</p>
                                    <p>{t.company.kvkLabel} {siteConfig.kvk}</p>
                                    {siteConfig.vat && <p>{t.company.vatLabel} {siteConfig.vat}</p>}
                                    <div className="flex items-center space-x-3">
                                        <Mail size={18} className="text-maat-gold" />
                                        <a href={`mailto:${siteConfig.social.email}`} className="text-maat-gold font-bold hover:underline">
                                            {siteConfig.social.emailLabel}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    );
};

export default PrivacyStatement;
